import React from "react";
import {useRef, useEffect, useState} from 'react';
import ReactDOMServer from "react-dom/server";
import axios from 'axios';
import iotPaths from '../../../assets/iotPaths.json';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faHeartPulse, faHourglassHalf, faPlay, faStop, faCamera, faTerminal, faList, faFileLines, faRotate, faSatelliteDish, faPowerOff, faCircleExclamation, faVideo} from '@fortawesome/free-solid-svg-icons';
import TerminalModal from '../../../component/terminalModal/terminalModal';
// import './iotCommandPanelStyle.css';

// A Panel that handles all API commands to remote computer and displays output
function IotCommandsPanel(props) {

    // const [terminalCommands, setTerminalCommands] = useState([]);
    const [modalItems, setmodalItem] = useState(null);

    const ref = useRef(null);

    const clearCommands = async() => {
        const commandsList = document.getElementById("commandslist");
        while(commandsList.hasChildNodes()) {
            commandsList.removeChild(commandsList.firstChild);
            // terminalCommands.pop();
        }
    }

    const createOutputMsg = (msg) => {
        // Grab current time and create timestamp
        const now = new Date(Date.now());
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');
        const timestamp = `${hours}:${minutes}:${seconds}`;

        const message = document.createElement('li');
        message.classList = "output-item";
        message.innerText =`${msg} | ${timestamp}`;
        document.getElementById('outputbox').append(message);
        document.getElementById('outputbox').scrollTop = document.getElementById('outputbox').scrollHeight;
    }

    // Function handles all different API calls and displays their response message on the DOM
    const apiRequest = async(command) => {
        try {
            // Grabs login token and creates request object for axios call
            const route = command;
            let isConfirmed = true;

            // If live camera button is clicked
            let liveCameraElm = null;

            const requestObject = {
                url: `${props.props.url}${iotPaths[route].path}`,
                method: iotPaths[route].method,
            }

            if(route === "live") {
                liveCameraElm = document.createElement("iframe");
                liveCameraElm.src = `${props.props.url}/live/camera/?apikey=${props.props.deviceData.apiKey}`;
                liveCameraElm.width = "670px";
                liveCameraElm.height = "500px";
                isConfirmed = false;
            }

            // if Commmand is not status add apiKey to headers
            if(route !== "status") {
                requestObject.headers = {"apiKey": props.props.deviceData.apiKey};
            }

            // if Commmand is takepicture set responseType to arrayBuffer
            if(route === "camera") {
                document.querySelector("#img-container").innerHTML = "";
                document.querySelector("#img-container").innerHTML += `<div class="lds-ring" id="lds-ring"><div></div><div></div><div></div><div></div></div>`;
                // requestObject.headers = {"apiKey": props.props.deviceData.apiKey};
                requestObject.data = {"format": "base64"};
            } else if(route === "setmodeultra") {
                const currentMode = document.getElementById("statuspanel-mode").innerText;
                if(currentMode === "passive") {
                    requestObject.data = {"mode": "active"};
                    createOutputMsg("Changing to Mode: active");
                }
                else if(currentMode === "active") {
                    requestObject.data = {"mode": "passive"};
                    createOutputMsg("Changing to Mode: passive");
                }
                else {
                    requestObject.data = {"mode": "passive"};
                    createOutputMsg("Changing to Mode: passive");
                }
                requestObject.headers = {"apiKey": props.props.deviceData.apiKey};
            } else if(route === "reboot") {
                // requestObject.data = {"cmd": ["sudo reboot now"]};
                isConfirmed = confirm(`Are you sure you want to Reboot ${props.props.deviceData.hostname}?`);
                !isConfirmed ? createOutputMsg("Canceled Reboot") : createOutputMsg("Device is Rebooting, please wait for it come back Online");
            } else if(route === "resetultra") {
                isConfirmed = confirm(`Are you sure you want to Reset the settings for ${props.props.deviceData.hostname}?`);
                !isConfirmed ? createOutputMsg("Canceled Reseting of sensor Settings") : createOutputMsg("Sensors Settings have been reset");
            }

            // if Command is 'hasData' add data property to requestObject
            if(iotPaths[route].hasData === true) {
                requestObject.data = {"cmd": terminalCommands};
            }

            let apiResponse = null;
            if(isConfirmed === true) apiResponse = await axios(requestObject);
            else apiResponse = {status: 0};
            // if call was successful set message in output panel and screenshot data too
            if(apiResponse.status === 200 || apiResponse.status === 201) {
                if(command === "camera" || command === "terminal") {
                    //alert("Screenshot Successfully fetched");
                    if(command === "terminal") {
                        createOutputMsg(`Executed Terminal commands: [${terminalCommands}]`);
                    }
                    createOutputMsg("Picture Successfully fetched");
                    // const base64 = btoa([].reduce.call(new Uint8Array(apiResponse.data.base64),function(p,c){return p+String.fromCharCode(c)},'')) Old way of converting image data into base64
                    document.querySelector("#img-container").innerHTML = `<img src='' id='cameraImg' />`;
                    document.getElementById("cameraImg").src = 'data:image/png;base64,' + apiResponse.data.base64;
                    // document.getElementById("lds-ring").parentNode.removeChild(document.getElementById("lds-ring")); // removes the lds spinning rings
                } else if(command === 'logs') {
                    createOutputMsg("Successfully fetched logs");

                    // Sets Data to be put in Logs box
                    for(let i = 0; i < apiResponse.data.length; i++) {
                        const paddingPX = "5px";
                        const log = document.createElement('li');
                        log.classList = "logItem";

                        // Create two different containers to hold Type and actual data for better UI
                        const nameGroup = document.createElement("div");
                        nameGroup.classList = "logNameElm";
                        const dataGroup = document.createElement("div");
                        dataGroup.classList = "logDataElm";

                        let address = document.createElement("span");
                        address.style.paddingBottom = paddingPX;
                        address.innerText = "Address:";
                        let addressData = document.createElement("span");
                        addressData.style.paddingBottom = paddingPX;
                        addressData.innerText = `${apiResponse.data[i].remoteAddress}`;

                        // let commands = document.createElement("span");
                        // commands.innerText = `Commands:`;
                        // let commandsData = document.createElement("span");
                        // commandsData.innerText = `${apiResponse.data[i].termCmd}`;

                        let reqBody = document.createElement("span");
                        reqBody.style.paddingBottom = paddingPX;
                        reqBody.innerText = `Body:`;
                        let reqBodyData = document.createElement("span");
                        reqBodyData.style.paddingBottom = paddingPX;
                        reqBodyData.innerText = `${JSON.stringify(apiResponse.data[i].body)}`;

                        let routeElm = document.createElement("span");
                        routeElm.style.paddingBottom = paddingPX;
                        routeElm.innerText = `Route:`;
                        let routeElmData = document.createElement("span");
                        routeElmData.style.paddingBottom = paddingPX;
                        routeElmData.innerText = `${apiResponse.data[i].routePath}`;

                        let timestamp = document.createElement("span");
                        timestamp.style.paddingBottom = paddingPX;
                        timestamp.style.color = "#e905cc";
                        timestamp.innerText = "Time:";
                        let timestampData = document.createElement("span");
                        timestampData.style.paddingBottom = paddingPX;
                        timestampData.innerText = `${apiResponse.data[i].time}`;
                        timestampData.style.color = "#e905cc";

                        nameGroup.append(address);
                        // nameGroup.append(commands);
                        nameGroup.append(reqBody);
                        nameGroup.append(routeElm);
                        nameGroup.append(timestamp);

                        dataGroup.append(addressData);
                        // dataGroup.append(commandsData);
                        dataGroup.append(reqBodyData);
                        dataGroup.append(routeElmData);
                        dataGroup.append(timestampData);

                        log.append(nameGroup);
                        log.append(dataGroup);

                        document.getElementById('logsbox').append(log);
                    }
                    document.getElementById('logsbox').scrollTop = document.getElementById('logsbox').scrollHeight;
                } else if(command === 'getsensorlogs') {
                    // Sets Data to be put in Output box
                    createOutputMsg("Successfully fetched sensor logs");

                    // Sets Data to be put in Logs box
                    for(let i = 0; i < apiResponse.data.length; i++) {
                        const log = document.createElement('li');
                        log.classList = "sensorLogItem";

                        // Create two different containers to hold Type and actual data for better UI
                        const nameGroup = document.createElement("div");
                        nameGroup.classList = "sensorlogNameElm";
                        const dataGroup = document.createElement("div");
                        dataGroup.classList = "sensorlogDataElm";

                        let distance = document.createElement("span");
                        distance.innerText = "Distance:";
                        let distanceData = document.createElement("span");
                        distanceData.innerText = `${Math.floor(apiResponse.data[i].distance)}${apiResponse.data[i].measurement}`;

                        let threshold = document.createElement("span");
                        threshold.innerText = `Threshold:`;
                        let thresholdData = document.createElement("span");
                        thresholdData.innerText = `${apiResponse.data[i].threshold}${apiResponse.data[i].measurement}`;

                        let breach = document.createElement("span");
                        breach.innerText = `Breach:`;
                        let breachData = document.createElement("span");
                        breachData.innerText = `${apiResponse.data[i].breach}`;

                        let mode = document.createElement("span");
                        mode.innerText = `Mode:`;
                        let modeData = document.createElement("span");
                        modeData.innerText = `${apiResponse.data[i].mode}`;

                        let timestamp = document.createElement("span");
                        timestamp.innerText = "Time:";
                        let timestampData = document.createElement("span");
                        timestampData.innerText = `${apiResponse.data[i].timestamp}`;
                        timestampData.style.color = "#e905cc";

                        nameGroup.append(distance);
                        nameGroup.append(threshold);
                        nameGroup.append(breach);
                        nameGroup.append(mode);
                        nameGroup.append(timestamp);

                        dataGroup.append(distanceData);
                        dataGroup.append(thresholdData);
                        dataGroup.append(breachData);
                        dataGroup.append(modeData);
                        dataGroup.append(timestampData);

                        log.append(nameGroup);
                        log.append(dataGroup);

                        document.getElementById('sensorlogsbox').append(log);
                    }
                    
                    document.getElementById('sensorlogsbox').scrollTop = document.getElementById('sensorlogsbox').scrollHeight;
                } else if(command === "statusultra") {
                    const isEnabled = apiResponse.data.sensor.isEnabled ? <>Scanning<FontAwesomeIcon className='status-icon rotate-icon' icon={faRotate} style={{color: "green"}} /></> : <>Idle<FontAwesomeIcon className='status-icon' icon={faHourglassHalf} style={{color: "orange"}} /></>;
                    document.getElementById('statuspanel-isenabled').innerHTML = ReactDOMServer.renderToString(isEnabled);
                    document.getElementById('statuspanel-mode').innerText = apiResponse.data.sensor.mode;
                    document.getElementById('statuspanel-threshold').innerText = apiResponse.data.sensor.threshold;
                    document.getElementById('statuspanel-lastdistance').innerText = `${Math.floor(apiResponse.data.sensor.lastDistance.value)}${apiResponse.data.sensor.lastDistance.measurement} ${apiResponse.data.sensor.lastDistance.timestamp}`;
                
                    createOutputMsg("Fetched Device Status");
                } else if(command === "setmodeultra") {
                    await apiRequest("statusultra");
                    // const currentMode = document.getElementById("statuspanel-mode").innerText;
                    // document.getElementById('statuspanel-mode').innerText = "active";

                    // createOutputMsg("Mode: active");
                } else if(command === "getultra") {
                    const now = new Date(Date.now());
                    const hours = now.getHours().toString().padStart(2, '0');
                    const minutes = now.getMinutes().toString().padStart(2, '0');
                    const seconds = now.getSeconds().toString().padStart(2, '0');
                    const timestamp = `${hours}:${minutes}:${seconds}`;
                    document.getElementById("statuspanel-lastdistance").innerText = `${Math.floor(apiResponse.data.Distance)}${apiResponse.data.Measurement} | ${timestamp}`;
    
                    createOutputMsg(`${Math.floor(apiResponse.data.Distance)}${apiResponse.data.Measurement}`);
                } else if(command === "resetultra") { 
                    createOutputMsg("Reset sensors settings Successfully");
                    await apiRequest("statusultra");
                } else {
                    // alert(apiResponse.data.message);
                    if(!apiResponse.data.message) createOutputMsg(`${apiResponse.data.status}`);
                    else createOutputMsg(`${apiResponse.data.message}`);
                    if(command === "startultra" || command === "stopultra") apiRequest("statusultra"); // update status of device
                }
            } else {
                if(command === "camera") {
                    // add error msg to output panel
                    createOutputMsg("Camera picture Failed");

                    document.getElementById("lds-ring").parentNode.removeChild(document.getElementById("lds-ring")); // removes the lds spinning rings
                    document.querySelector("#img-container").innerHTML += `<p class="img-error-msg">Something went wrong with fetching the Camera picture... try again</p>`;
                    alert("ERROR Something went wrong, please try again");
                } else if(command === 'live') {
                    // Since this isnt an /api route call we will instead replace with live-camera feed
                    document.querySelector("#img-container").removeChild(document.getElementById("camera-message") || document.querySelector("img")); // removes the lds spinning rings
                    document.querySelector('#img-container').appendChild(liveCameraElm);

                    createOutputMsg("Live Camera activated");

                    const statusApi = await apiRequest("statusultra") // update status of device
                    if(!statusApi) document.getElementById('statuspanel-isenabled').innerHTML = ReactDOMServer.renderToString(<>Live<FontAwesomeIcon className='status-icon' icon={faVideo} style={{color: "red"}} /></>);
                } else alert("ERROR Something went wrong, please try again");
            }
        } catch (err) {
            console.log(err);
        }
    }

    // May need to use later
    useEffect(() => {
        // Function handle adding a terminal command to request body of API call
        const handleSubmit = (e) => {
            e.preventDefault();

            terminalCommands.push(e.target.command.value);

            const badge = document.createElement("span");
            badge.classList = "btn btn-light border m-2";
            badge.innerText = e.target.command.value;
            
            const arrowElm = document.createElement("span");
            arrowElm.classList = "m-2";
            arrowElm.innerText = ">";
            
            document.getElementById("commandslist").append(badge);
            document.getElementById("commandslist").append(arrowElm);
        };

        const modalList = [];
        const terminalItem = React.createElement(TerminalModal, {key: "terminal", name: "Terminal", url: `https://${props.props.domainName}:${props.props.port}`, apiKey: props.props.apiKey});
        modalList.push(terminalItem);
        setmodalItem(modalList);


        // const element = ref.current;
        
        // element.addEventListener('submit', handleSubmit);

        // return () => {
        //     element.removeEventListener('submit', handleSubmit);
        // };
    },[]);

    return(
        <article className='flex-nogap column border rounded max-width-lg min-width-250px max-width-250px min-height-lg max-height-lg'>
            <section className='flex justify-content-cntr align-items-cntr border-bottom font-sm width-250px'>
                <h5 className='padding-t-sm padding-b-sm'>Commands:</h5>
            </section>
            <section className='flex-nogap row flex-wrap overflow-scroll overflow-x-hidden max-height-lg'>
                <button className='height-40px width-40px flex row justify-content-cntr align-items-cntr bg-color-background border rounded hover-cursor border-color-foreground' onClick={() => apiRequest("status")} data-toggle="tooltip" data-placement="bottom" title="Status of Device"><FontAwesomeIcon icon={faHeartPulse} size='2xl' color='hotpink' /></button>
                <button className='height-40px width-40px flex row justify-content-cntr align-items-cntr bg-color-background border rounded hover-cursor border-color-foreground' onClick={() => apiRequest("startultra")} data-toggle="tooltip" data-placement="bottom" title="Start Motion Senor"><FontAwesomeIcon icon={faPlay} size='2xl' color='green' /></button>
                <button className='height-40px width-40px flex row justify-content-cntr align-items-cntr bg-color-background border rounded hover-cursor border-color-foreground' onClick={() => apiRequest("stopultra")} value='stopultra' data-toggle="tooltip" data-placement="bottom" title="Stop Motion Sensor"><FontAwesomeIcon icon={faStop} size='2xl' color='red' /></button>
                <button className='height-40px width-40px flex row justify-content-cntr align-items-cntr bg-color-background border rounded hover-cursor border-color-foreground' onClick={() => apiRequest("setmodeultra")} value='setmodeultra' data-toggle="tooltip" data-placement="bottom" title="Toggle Sensor Mode"><FontAwesomeIcon icon={faList} size='2xl' color='lightblue' /></button>
                <button className='height-40px width-40px flex row justify-content-cntr align-items-cntr bg-color-background border rounded hover-cursor border-color-foreground' onClick={() => apiRequest("getultra")} value='getultra' data-toggle="tooltip" data-placement="bottom" title="Get single sensor log"><FontAwesomeIcon icon={faSatelliteDish} size='2xl' color='lightblue' /></button>
                <button className='height-40px width-40px flex row justify-content-cntr align-items-cntr bg-color-background border rounded hover-cursor border-color-foreground' onClick={() => apiRequest("camera")} value='camera' data-toggle="tooltip" data-placement="bottom" title="Take a Picture"><FontAwesomeIcon icon={faCamera} size='2xl' color='yellow' /></button>
                <button className='height-40px width-40px flex row justify-content-cntr align-items-cntr bg-color-background border rounded hover-cursor border-color-foreground' onClick={() => apiRequest("live")} value='live' data-toggle="tooltip" data-placement="bottom" title="Live Camera"><FontAwesomeIcon icon={faVideo} size='2xl' color='red' /></button>
                <button className='height-40px width-40px flex row justify-content-cntr align-items-cntr bg-color-background border rounded hover-cursor border-color-foreground' onClick={() => apiRequest("getsensorlogs")} data-toggle="tooltip" data-placement="bottom" title="Sensor Logs"><FontAwesomeIcon icon={faFileLines} size='2xl' color='purple' /></button>
                <button className='height-40px width-40px flex row justify-content-cntr align-items-cntr bg-color-background border rounded hover-cursor border-color-foreground' onClick={() => apiRequest("logs")} value='logs' data-toggle="tooltip" data-placement="bottom" title="Get Logs"><FontAwesomeIcon icon={faFileLines} size='2xl' color='white' /></button>
                <button className='height-40px width-40px flex row justify-content-cntr align-items-cntr bg-color-background border rounded hover-cursor border-color-foreground' onClick={() => apiRequest("reboot")} data-toggle="tooltip" data-placement="bottom" title="Reboot Device"><FontAwesomeIcon icon={faPowerOff} size='2xl' color='orange' /></button>
                <button className='height-40px width-40px flex row justify-content-cntr align-items-cntr bg-color-background border rounded hover-cursor border-color-foreground' onClick={() => apiRequest("resetultra")} data-toggle="tooltip" data-placement="bottom" title="Reset Sensor Settings"><FontAwesomeIcon icon={faCircleExclamation} size='2xl' color='grey' /></button>
                {modalItems}
            </section>
        </article>
    );
}

export default IotCommandsPanel;
